export enum WorkflowStatusEnum {
  Archived = "Archived",
  Active = "Active",
}

export enum WorkflowNodesStatusEnum {
  Published = "Published",
  Draft = "Draft",
}
